/**
 * Iniciais em maiúsculas das primeiras palavras do texto, ignorando conectivos e símbolos.
 * Texto com uma única palavra devolve as primeiras letras dela
 */
export function getInitials(text?: string | null, length = 2): string {
  const words = (text ?? '')
    .split(/[\s\-_/]+/)
    .map(word => word.replace(/[^\p{L}\p{N}]/gu, ''))
    .filter(Boolean)

  const significantWords = words.filter(word => !CONNECTIVES.has(word.toLowerCase()))
  const selectedWords = significantWords.length ? significantWords : words

  const initials =
    selectedWords.length === 1
      ? selectedWords[0].slice(0, length)
      : selectedWords
          .slice(0, length)
          .map(word => word.charAt(0))
          .join('')

  return initials.toUpperCase()
}

/** Conectivos ignorados na geração das iniciais */
const CONNECTIVES = new Set(['and', 'da', 'das', 'de', 'del', 'do', 'dos', 'e', 'of', 'the', 'y'])
